import React from 'react';
import { MeatballMenu, ButtonCallToAction, ButtonTertiary, PromptConfirmationModal } from 'ui';
import { Tag } from 'app/components/tag';
import { isDisabled } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import * as navigate from 'app/area/shared/navigation';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import { getBackRoute } from '../route';
import { ImportSetActionType, ImportSetStickyHeaderProps } from '../types';
import { replaceTemplateString } from 'app/infrastructure/platform';
import styles from './import-set-sticky-header.scss';

export const ImportSetStickyHeader: React.FC<ImportSetStickyHeaderProps> = ({
  actionType, importSetItem, name, fetching, translation, onSave, onDuplicate, onDelete
}) => {

  const updatingItem = isDefinedIncludingZero(importSetItem?.id);
  const handleMissingCodes = () => navigate.toImportMappingsList(importSetItem?.id);
  const onCancel = () => {
    navigate.to({ pathname: getBackRoute() });
  };

  return <>
    <StickyHeader
      className={styles.header}
      rightSideContent={<>
        <StickyHeaderButtonContainer>
          <ButtonTertiary
            id="import-set-form-sticky-header-cancel-button"
            onClick={onCancel}>
            {translation.cancel}
          </ButtonTertiary>
          <ButtonCallToAction
            id="import-set-form-sticky-header-save-button"
            onClick={onSave}
            disabled={false}>
            {translation.save}
          </ButtonCallToAction>
        </StickyHeaderButtonContainer>
        {actionType === ImportSetActionType.edit && importSetItem.id !== 0
          ? <MeatballMenu id="import-set-form-sticky-header-meatballmenu">
            <li>
              <button
                type="button"
                className="dropdown-item"
                onClick={onDuplicate}>
                {translation.duplicate_import_set}
              </button>
            </li>
            {isDefinedIncludingZero(importSetItem?.id) && <li>
              <button type="button"
                className="dropdown-item"
                onClick={handleMissingCodes}>
                {translation.import_codes}
              </button>
            </li>}
            <li>
              <PromptConfirmationModal
                title={translation.delete_import_set_title}
                description={replaceTemplateString(
                  translation.delete_confirmation,
                  name)}
                continueText={translation.delete_import_set_button}
                cancelText={translation.cancel}
                onContinue={onDelete}>
                <button type="button" className="dropdown-item" disabled={fetching}>
                  {translation.delete_import_set_button}
                </button>
              </PromptConfirmationModal>
            </li>
          </MeatballMenu> : null}
      </>} >
      <div className={styles.headerContainer}>
        {actionType !== ImportSetActionType.duplicate
          ? <>
            {updatingItem ? <span className={styles.headerId}>
              #{importSetItem.id}
            </span> : null}
            <h2 className={styles.headerTitle}>
              {updatingItem
                ? name || null
                : translation.new_import_set}
            </h2>
          </>
          : <h2 className={styles.headerTitle}>
            {translation.duplicate_title}
          </h2>}
        {isDisabled(importSetItem.disabled) ? <Tag>{translation.disabled}</Tag> : null}
      </div>
    </StickyHeader>
  </>;
};
